import { GenericArrayFactory } from "../../../Budgets/_generics";

export const ModulesStore = GenericArrayFactory("MODULES");